//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions} from 'vuex';
  export default {
      name: "complete",
    data(){
      return {
        persent:0,
        title:[
          '字母级',
          'Pre-R level',
          'Emergent',
          'Early 1',
          'Early 2',
          'Early 3',
          'Early 4',
          'Fluecy'
        ]
      }
    },
    computed:{
      result(){
        if(this.$store.state.testStatus.passed==1){
          if(this.$store.state.testLevel<=0){
            return this.title[0];
          }else{
            return this.title[this.$store.state.testLevel-1];
          }
        }
        if(this.$store.state.testStatus.passed==2){
          if(this.$store.state.testLevel>=7){
            return this.title[7];
          }else{
            return this.title[this.$store.state.testLevel+1];
          }
        }
      }
    },
    methods:{
        ...mapActions(["changeTestLevel"]),
      next(){
        var status=this.$store.state.testStatus.data;
        var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
        var nextroute='';
        for(var key in tixing){
          if(!status[tixing[key]].tested){
            nextroute=tixing[key];
            break;
          }
        }
        this.$router.replace({name:nextroute});
      },
      skip(){
        var test_result=this.$store.state.testStatus.passed==2?1:2;
        this.axios.post('/xcx/Order/testRecommend',{test_result,type:this.$store.state.testLevel+1}).then(res=>{
          this.$router.replace({name:'tutorial'})
        })
        // this.axios.post('/xcx/Order/testStatus',{type:this.$store.state.testLevel+1}).then(res=>{
        //   this.$router.replace({name:'tutorial'})
        // })
      },
      jixu(){
        if(this.$store.state.testStatus.passed==2){     //通过题目升级
          this.changeTestLevel(this.$store.state.testLevel+1);
        }
        if(this.$store.state.testStatus.passed==1){     //不通过题目降级
          this.changeTestLevel(this.$store.state.testLevel-1);
        }
        this.$router.replace({name:'test'});
      }
    },
    created() {
        var persent=(this.$route.query.zq/(this.$route.query.zq+this.$route.query.cw))*100;
        this.persent=persent.toFixed(1);
    }
  }



// WEBPACK FOOTER //
// ./src/components/complete/complete.vue